import { Injectable, TemplateRef } from "@angular/core";
import { Subject } from "rxjs";

export interface SnackItem {
  message: string;
  actionText?: string;
  duration?: number;
  persistent?: boolean;
  customTrailingIcon?: TemplateRef<any>;
}

@Injectable({
  providedIn: "root",
})
// Snackbar queue service that allow other part in the app to push snackbar message to be displayed
export class SnackbarService {
  private snackRequest$ = new Subject<SnackItem>();

  get snack$() {
    return this.snackRequest$.asObservable();
  }

  show(snackItem: SnackItem): void {
    this.snackRequest$.next(snackItem);
  }
}
